import { gql } from '@apollo/client'

export const moveUserToRootMutation = gql`
  mutation MoveUserToRoot($accessToken: String!) {
    moveUserToRoot(accessToken: $accessToken) {
      id
      name
    }
  }
`
